export default "__VITE_ASSET__842bbb0a__"